/* eslint-disable */

const actions = {
  SEARCH_HEADER_BEGIN: 'SEARCH_HEADER_BEGIN',
  SEARCH_HEADER_SUCCESS: 'SEARCH_HEADER_SUCCESS',
  SEARCH_HEADER_ERR: 'SEARCH_HEADER_ERR',
  ADD_SELECTED_USER: 'ADD_SELECTED_USER',

  searchHeaderBegin: () => ({ type: actions.SEARCH_HEADER_BEGIN }),
  searchHeaderSuccess: (data) => ({ type: actions.SEARCH_HEADER_SUCCESS, data }),
  searchHeaderErr: (err) => ({ type: actions.SEARCH_HEADER_ERR, err }),
  addSelectedUser: (data) => ({ type: actions.ADD_SELECTED_USER, data }),
};

export default actions;
